import Body3AccentTypography from '@components/atoms/typography/body3-accent/body3-accent';
import CaptionTypography from '@components/atoms/typography/caption/caption';
import { combineDateAndTimeRange } from 'src/utils/formats/dates';
import type { FormattedDateRangeObject } from './date-range-view-types';

export function DateRangeTooltip({ restRanges }: { restRanges: FormattedDateRangeObject[] }) {
	return (
		<div className="flex flex-col" data-aid="date-range-tooltip">
			{restRanges?.map((range, index) => (
				<div key={`${index}-${range.formattedDateRange}`}>
					<CaptionTypography className="text-primary">
						{combineDateAndTimeRange(range.formattedDateRange, range.formattedTimeRange)}
					</CaptionTypography>
					{range.formattedExtraDetails.map((detail, innerIndex) => (
						<Body3AccentTypography key={`${index}-${innerIndex}`}>{detail}</Body3AccentTypography>
					))}
				</div>
			))}
		</div>
	);
}
